'use strict';

// Constructor
var BackTop = function () {
    // Add the back to top button
    $('body').append('<a id="return-to-top"><span class="icon-arrow-up"></span><span>Top</span></a>');

    // Click show hide and click action
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 100) {        // If page is scrolled more than 100px
            $('#return-to-top').addClass('show');    // Fade in the arrow
        } else {
            $('#return-to-top').removeClass('show');   // Else fade out the arrow
        }
    });
    $('#return-to-top').click(function () {      // When arrow is clicked
        $('body,html').animate({
            scrollTop: 0                       // Scroll to top of body
        }, 1000);
    });

    // When window resize recompute back top position
    $(window).resize(function () {
        backTopPosition();
    });

    backTopPosition();

};

module.exports = BackTop;

function backTopPosition() {
    if (window.innerWidth > 1440) {
        var $pageContainer = $('.o-pageHead + .a-pageContainer');
        var left = $pageContainer.offset().left + $pageContainer.width() + 60;
        $('#return-to-top').css('left', left);
    }
    else if (window.innerWidth < 1350) {
        var $pageContainer = $('.o-pageHead + .a-pageContainer');
        var left = $pageContainer.offset().left + $pageContainer.width() - 60;
        $('#return-to-top').css('left', left);
    }
    else if (window.innerWidth > 1024) {
        var $pageContainer = $('.o-pageHead + .a-pageContainer');
        var left = $pageContainer.offset().left + $pageContainer.width();
        $('#return-to-top').css('left', left);
    }
}